// eslint-disable-next-line import/no-extraneous-dependencies
import videojs from 'video.js/dist/alt/video.novtt.js';

(function ($) {
  const $popup = $('#slider-box__popup');
  let $lastVideoBlock = '';
  let cloudflarePlayer = null;

  $('.slider-box__triple-video').on('click', (event) => {
    if (event.target.closest('.video-pause-control') || event.target.closest('svg')) {
      return;
    }

    const tripleVideo = $(event.target).closest('.triple-video__video');
    const videoId = tripleVideo.attr('data-video-id');
    const videoSubtitleUrl = tripleVideo.attr('data-subtitle-url');
    const videoProvider = tripleVideo.attr('data-video-provider');

    $lastVideoBlock = tripleVideo;

    $popup.modal({
      fadeDuration: 250,
      showSpinner: false,
      blockerClass: 'c-popup--blocker slider-box__triple-video--blocker',
      modalClass: 'slider-box__popup',
      closeClass: 'slider-box__close',
      showClose: true,
      escapeClose: true,
    });

    if (videoProvider === 'youtube') {
      $popup.html('').append(`<iframe src="https://www.youtube.com/embed/${videoId}?rel=0&cc_load_policy=1&autoplay=1&showinfo=0&mute=1&loop=1" width="100%" height="100%" type="text/html" frameborder="0" allow="autoplay"></iframe>`);
    } else if (videoProvider === 'vimeo') {
      $popup.html('').append(`<iframe src="https://player.vimeo.com/video/${videoId}?autoplay=1&texttrack=en&byline=false&title=false" class="c-video" width="100%" height="100%" frameborder="0" allow="autoplay"></iframe>`);
    } else if (videoProvider === 'cloudflare') {
      const cloudflareVideoUrl = tripleVideo.attr('data-cloudflare-video-url');
      $popup.html('');
      const $video = $('<video-js class="video-js vjs-big-play-centered c-video" preload="auto" controls playsinline></video-js>');
      if (cloudflareVideoUrl) {
        $video.append(`<source src="${cloudflareVideoUrl}" type="video/mp4">`);
        if (videoSubtitleUrl) {
          $video.append(`<track src="${videoSubtitleUrl}" kind="subtitles" srclang="en" label="English">`);
        }
        $video.append('Your browser does not support the video tag.');
        $popup.append($video);
        cloudflarePlayer = videojs($video[0], {
          autoplay: true,
          controls: true,
          fluid: true,
          loop: true,
          muted: false,
        });
        cloudflarePlayer.ready(() => {
          cloudflarePlayer.play();
        });
      }
    } else {
      $popup.html('').append(`<video crossorigin="anonymous" preload="auto" autoPlay="true" playsInline="" tabIndex="0" controls="true" className="c-video" height="100%" width="100%">
      <source src="${videoId}" type="video/mp4">
      <track src="${videoSubtitleUrl}" kind="subtitles" srclang="en" label="English">
      Your browser does not support the video tag.
    </video>`);
    }
  });

  if ($.modal) {
    $popup.on($.modal.BEFORE_CLOSE, () => {
      if (cloudflarePlayer && !cloudflarePlayer.disposed) {
        cloudflarePlayer.dispose();
        cloudflarePlayer = null;
      }
      $popup.html('');
    });

    $popup.on($.modal.AFTER_CLOSE, () => {
      if ($lastVideoBlock) {
        $lastVideoBlock.find('.triple-video__player--text').focus();
      }
    });
  }
// eslint-disable-next-line no-undef
}(jQuery));
